module.exports = __webpack_public_path__ + "img/logo-bancoMercantil.82e847f1.svg";